import * as React from 'react';
import './DropdownContentDiv.scss';

export type DropdownButtonsProps = {
    children?: React.ReactNode;
} & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

/**
 * A component that wraps the contents within a dropdown if those contents are multiple buttons.
 * This is helpful just for the styles to be reused.
 */
export default class DropdownContentDiv extends React.Component<DropdownButtonsProps> {
    render() {
        const { className: extraClasses, ...props } = this.props;
        return (
            <div className={`dropdown-content-buttons ${extraClasses || ''}`} {...props}>
                {this.props.children}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Dropdown/DropdownContentDiv.tsx